import { Layout } from '@/components/generic';
import { useTranslation } from 'react-i18next';

import { Overview } from './Overview';
import SelfCustodyDisclaimer from './SelfCustodyDisclaimer';
import TransactionsHistory from './TransactionsHistory';
import { WalletActions } from './WalletActions';

export const Dashboard = () => {
  const { t } = useTranslation();

  return (
    <div className='min-h-screen bg-b-surface1 font-inter text-body-1 text-t-primary antialiased'>
      <Layout title={t('wallet.title')}>
        <WalletActions />
        <Overview />
        <SelfCustodyDisclaimer />
        <TransactionsHistory />
      </Layout>
    </div>
  );
};
